import withUserPrefs from '../../../hoc/withUserPrefs';
import auth from '../../../providers/auth';
import userPrefs from '../../../providers/userPrefs';

import PopupNotifications from './PopupNotifications';

export default withUserPrefs()(PopupNotifications);

auth.on('logout', () => {
    userPrefs.remove('disablePopupNotifications')
})
